/**
 * StreamLain entry of the table row menu: "Automation runs" opens the
 * automation sidebar with the runs this row started.
 */
import { I18n } from '@affine/i18n';
import { RowMenuExtensionRegistration } from '@blocksuite/affine/data-view';
import { menu } from '@blocksuite/affine-components/context-menu';
import { HistoryIcon } from '@blocksuite/icons/lit';

import {
  OPEN_ROW_AUTOMATION_HISTORY_EVENT,
  type RowHistoryTarget,
} from './services/automation';

export const AutomationRunsRowMenuExtension = RowMenuExtensionRegistration({
  id: 'streamlain-automation-runs',
  items: ({ databaseId, rowId }) => [
    menu.group({
      items: [
        menu.action({
          name: I18n.t('com.streamlain.automation.row-menu.runs'),
          prefix: HistoryIcon(),
          select: () => {
            window.dispatchEvent(
              new CustomEvent<RowHistoryTarget>(
                OPEN_ROW_AUTOMATION_HISTORY_EVENT,
                { detail: { databaseId, rowId } }
              )
            );
          },
        }),
      ],
    }),
  ],
});
